"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @export
 * @enum {string}
 */

var ReplyStrategyEnum;

(function (ReplyStrategyEnum) {
  ReplyStrategyEnum["PUBLIC"] = "PUBLIC";
  ReplyStrategyEnum["PRIVATE"] = "PRIVATE";
})(ReplyStrategyEnum = exports.ReplyStrategyEnum || (exports.ReplyStrategyEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */


var MetaformFieldType;

(function (MetaformFieldType) {
  MetaformFieldType["Text"] = "text";
  MetaformFieldType["Url"] = "url";
  MetaformFieldType["Hidden"] = "hidden";
  MetaformFieldType["Email"] = "email";
  MetaformFieldType["Number"] = "number";
  MetaformFieldType["Memo"] = "memo";
  MetaformFieldType["Boolean"] = "boolean";
  MetaformFieldType["Radio"] = "radio";
  MetaformFieldType["Checklist"] = "checklist";
  MetaformFieldType["Date"] = "date";
  MetaformFieldType["Time"] = "time";
  MetaformFieldType["DateTime"] = "date-time";
  MetaformFieldType["Files"] = "files";
  MetaformFieldType["Table"] = "table";
  MetaformFieldType["Logo"] = "logo";
  MetaformFieldType["SmallText"] = "small-text";
  MetaformFieldType["Html"] = "html";
  MetaformFieldType["Submit"] = "submit";
  MetaformFieldType["Select"] = "select";
  MetaformFieldType["Autocomplete"] = "autocomplete";
  MetaformFieldType["AutocompleteMultiple"] = "autocomplete-multiple";
})(MetaformFieldType = exports.MetaformFieldType || (exports.MetaformFieldType = {}));
/**
 *
 * @export
 * @enum {string}
 */


var MetaformTableColumnType;

(function (MetaformTableColumnType) {
  MetaformTableColumnType["Hidden"] = "hidden";
  MetaformTableColumnType["Text"] = "text";
  MetaformTableColumnType["Url"] = "url";
  MetaformTableColumnType["Email"] = "email";
  MetaformTableColumnType["Autocomplete"] = "autocomplete";
  MetaformTableColumnType["Number"] = "number";
  MetaformTableColumnType["Enum"] = "enum";
  MetaformTableColumnType["Date"] = "date";
  MetaformTableColumnType["Time"] = "time";
  MetaformTableColumnType["Html"] = "html";
  MetaformTableColumnType["Button"] = "button";
})(MetaformTableColumnType = exports.MetaformTableColumnType || (exports.MetaformTableColumnType = {}));
/**
 *
 * @export
 * @enum {string}
 */


var ReplyExportFormat;

(function (ReplyExportFormat) {
  ReplyExportFormat["XLSX"] = "XLSX";
  ReplyExportFormat["PDF"] = "PDF";
})(ReplyExportFormat = exports.ReplyExportFormat || (exports.ReplyExportFormat = {}));